module.exports = __webpack_public_path__ + "static/img/134_TO8_1828.c566da2.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/134_TO8_1828.jpg
// module id = CxMr
// module chunks = 0